export const TIM_WEB = 'TIM_WEB' as const;
export const TIM_WEBMOB = 'TIM_WEBMOB' as const;
export const MEU_TIM = 'MEU_TIM' as const;
export const TIM_BETA_APP = 'TIM_BETA_APP' as const;
export const CAPTIVE_PORTAL = 'CAPTIVE_PORTAL' as const;
export const TIM_ATIVACAO_CHIP = 'TIM_ATIVACAO_CHIP' as const;
export const TIM_INCENTIVO_PROGRAMADA = 'TIM_INCENTIVO_PROGRAMADA' as const;
export const TIM_LEMBRETE_PIX_NAO_PAGO = 'TIM_LEMBRETE_PIX_NAO_PAGO' as const;
export const TIM_URA = 'TIM_URA' as const;
export const TIM_FALLBACK_SMS = 'TIM_FALLBACK_SMS' as const;
export const TIM_SMS_URA = 'TIM_SMS_URA' as const;
export const TIM_DMA_WEB = 'TIM_DMA_WEB' as const;
export const TIM_DMA_144_WEB = 'TIM_DMA_144_WEB' as const;
export const TIM_DMA_222_WEB = 'TIM_DMA_222_WEB' as const;
export const TIM_DMA_244_WEB = 'TIM_DMA_244_WEB' as const;
export const TIM_DMA_1056_WEB = 'TIM_DMA_1056_WEB' as const;
export const TIM_TELEGRAM_WEB = 'TIM_TELEGRAM_WEB' as const;
export const TIM_APPLE_WEB = 'TIM_APPLE_WEB' as const;
export const TIM_WHATSAPP_BR_WEB = 'TIM_WHATSAPP_BR_WEB' as const;
// Troca de número (MSISDN) — não é fluxo de recarga: nenhum texto exibido
// neste canal pode mencionar "recarga" (exigência da TIM).
export const TIM_TROCA_MSISDN = 'TIM_TROCA_MSISDN' as const;

// Canais de app (escondem botão de saída)
export const APP_CHANNELS = [MEU_TIM, TIM_BETA_APP] as const;

// Canais que redirecionam para fluxo PIX após login
export const PIX_CHANNELS = [
  TIM_URA,
  TIM_LEMBRETE_PIX_NAO_PAGO,
  TIM_FALLBACK_SMS,
] as const;

// ─────────────────────────────────────────────────────────────────────────────
// Canais válidos — fonte de verdade da aplicação
//
// Até 2026-09 esta lista vinha do BFF via `GET /channel/settings-list`. A chamada
// foi removida na TPC-3672: era a primeira da cadeia de login e custava 0,35s no
// p50 e 1,41s no p95, além de forçar toda a validação de canal a ser assíncrona
// (ver docs/investigacoes/2026-08-27-medicao-lentidao-autologado-new-relic.md).
//
// Esta é a primeira etapa da remoção do endpoint no BFF. Enquanto ele existir,
// as duas listas convivem — ao criar ou renomear canal lá, atualizar aqui
// também. Depois da remoção, este arquivo passa a ser a única fonte.
//
// `reportUnknownChannel` (src/utils/reportUnknownChannel.ts) notifica o New Relic
// quando chega um canal fora destas listas, para que qualquer divergência
// apareça como alerta em vez de /404 silencioso.
// ─────────────────────────────────────────────────────────────────────────────

export const MOBILE_CHANNELS = [
  TIM_WEBMOB,
  MEU_TIM,
  TIM_BETA_APP,
  TIM_URA,
  TIM_LEMBRETE_PIX_NAO_PAGO,
  TIM_INCENTIVO_PROGRAMADA,
  CAPTIVE_PORTAL,
  TIM_DMA_WEB,
  TIM_TELEGRAM_WEB,
  TIM_APPLE_WEB,
  TIM_DMA_244_WEB,
  TIM_DMA_1056_WEB,
  TIM_DMA_144_WEB,
  TIM_DMA_222_WEB,
  TIM_WHATSAPP_BR_WEB,
  TIM_SMS_URA,
  TIM_FALLBACK_SMS,
  TIM_ATIVACAO_CHIP,
  TIM_TROCA_MSISDN,
] as const;

export const DESKTOP_CHANNELS = [TIM_WEB] as const;

// Union das duas — é contra esta lista que as páginas de entrada validam o
// canal recebido na URL antes de liberar o login.
export const ALL_CHANNELS: readonly string[] = [
  ...DESKTOP_CHANNELS,
  ...MOBILE_CHANNELS,
];
